"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withLayoutContext = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNativeWeb = require("react-native-web");

var _LayoutContextHelpers = require("./LayoutContextHelpers");

var _LayoutConstants = require("./LayoutConstants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var defaultState = {
  layoutReady: _reactNativeWeb.Platform.OS !== 'web',
  layout: _reactNativeWeb.Platform.OS === 'web' ? _LayoutConstants.LAYOUT.largeDesktop : (0, _LayoutContextHelpers.getLayout)(_reactNativeWeb.Dimensions.get('window').width)
};

var _React$createContext = /*#__PURE__*/React.createContext(defaultState),
    Provider = _React$createContext.Provider,
    Consumer = _React$createContext.Consumer;

var LayoutContextProvider = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(LayoutContextProvider, _React$Component);

  var _super = _createSuper(LayoutContextProvider);

  function LayoutContextProvider() {
    var _this;

    (0, _classCallCheck2["default"])(this, LayoutContextProvider);
    _this = _super.call(this);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleDimensionsChange", function () {
      var width = _reactNativeWeb.Dimensions.get('window').width;

      var layout = _this.state.layout;
      var newLayout = (0, _LayoutContextHelpers.getLayout)(width);

      if (layout !== newLayout) {
        _this.setState({
          layout: newLayout
        });
      }
    });
    _this.state = _objectSpread({}, defaultState);
    return _this;
  }

  (0, _createClass2["default"])(LayoutContextProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var layout = (0, _LayoutContextHelpers.getLayout)(_reactNativeWeb.Dimensions.get('window').width);

      if (!this.state.layoutReady || this.state.layout !== layout) {
        this.setState({
          layoutReady: true,
          layout: layout
        });
      }

      _reactNativeWeb.Dimensions.addEventListener('change', this.handleDimensionsChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _reactNativeWeb.Dimensions.removeEventListener('change', this.handleDimensionsChange);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Provider, {
        value: this.state
      }, this.props.children);
    }
  }]);
  return LayoutContextProvider;
}(React.Component);

exports["default"] = LayoutContextProvider;

var withLayoutContext = function withLayoutContext(Component) {
  return function LayoutComponent(props) {
    return /*#__PURE__*/React.createElement(Consumer, null, function (contexts) {
      return /*#__PURE__*/React.createElement(Component, (0, _extends2["default"])({}, props, contexts));
    });
  };
};

exports.withLayoutContext = withLayoutContext;